import React from 'react';
import CXBuilderMultiProject from './components/CXBuilderMultiProject';

function App() {
  return <CXBuilderMultiProject />;
}

export default App;
